import http from '../../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1',
	//-------------------销售经理工作台-------------------
    //产品销量查询
    getProductSale(query){
        return http({
            url: this.baseurl+'/vdm/vDmJingshouru/getMonthlyProductSale',
            method: 'post',
            params: query
        });
    },
	getSaleDataByRegion(query){
		return http({
		    url: this.baseurl+'/vdm/vDmJingshouru/getSaleDataByRegion',
		    method: 'post',
		    params: query
		});
	},
	//跑动排行
	getUserCareRanking(query){
		return http({
		    url: this.baseurl+'/guanhuai/userCareRanking/getRanking',
		    method: 'post',
		    params: query
		});
	},
	//资源需求排名  完成度排名接口
	getOverRanking(query){
		return http({
		    url: this.baseurl+'/xuqiu/userResDemandDept/showOverRanking',
		    method: 'post',
		    params: query
		});
	},
	// 响应时间排名，根据date字段的大小进行排名
	getTimeRanking(query){
		return http({
		    url: this.baseurl+'/xuqiu/userResDemandDept/showTimeRanking',
		    method: 'post',
		    params: query
		});
	},
	//地区销量排行
	getAreaSale(query){
		return http({
		    url: this.baseurl+'/vdm/vDmJingshouru/getMonthlyAreaSale',
		    method: 'post',
		    params: query
		});
	},
	//绩效排名
	getJiXiaoRanking(query){
		return http({
		    url: this.baseurl+'/xuqiu/userResProDetail/getJiXiaoRanking',
		    method: 'post',
		    params: query
		});
	},
	//信贷使用
	getCreditStatus(query){
		return http({
		    url: this.baseurl+'/infoCredit/userInfoCredit/selectMoneyStatus',
		    method: 'post',
		    params: query
		});
	},
	//项目漏斗
	showLoud(query){
		return http({
		    url: this.baseurl+'/demo/bscLoud/showLoud',
		    method: 'post',
		    params: query
		});
	},
	//经销商销量报表
	getAgentMonthlySale(query){
		return http({
		    url: this.baseurl+'/hetong/bscContractTarget/getAgentMonthlySale',
		    method: 'post',
		    params: query
		});
	},

	//经销商文件是否到期
	getFileEffectiveDate(query){
		return http({
			url: this.baseurl+'/agent/bscUserInfoAgent/getFileEffectiveDate',
			method: 'post',
			params: query
		});
	},
	//经销商文件是否到期
	getHavepolicy2017(query){
		return http({
			url: this.baseurl+'/agent/bscUserInfoAgent/getHavepolicy2017',
			method: 'post',
			params: query
		});
	},


	//----------------小微主工作台-------------------
	getXwzMonthlySale(query){
		return http({
		    url: this.baseurl+'/vdm/vDmJingshouru/getXwzMonthlySale',
		    method: 'post',
		    params: query
		});
	},
	//------------财务人员工作台--------------
	//金额报表
	getOrderPrice(query){
		return http({
		    url: this.baseurl+'/dingdmain/selectOrderPrice',
		    method: 'post',
		    params: query
		});
	},
	//订单保障度
	getOrderGuarantee(query){
		return http({
		    url: this.baseurl+'/dingdmain/selectOrderPrice',
		    method: 'post',
		    params: query
		});
	},
	//--------经销商工作台------------
	//销售目标
	getAgentSaleInfo(query){
		return http({
		    url: this.baseurl+'/dingdmain/selectAgentSaleInfo',
		    method: 'post',
		    params: query
		});
	},
	//余额信贷
	getAgentCreditInfo(query){
		return http({
		    url: this.baseurl+'/infoCredit/userInfoCredit/getAgentCreditInfo',
		    method: 'post',
		    params: query
		});
	},
	//返利图表
	getAgentRebateInfo(query){
		return http({
		    url: this.baseurl+'/custcash/bscCustcashSum/getAgentRebateInfo',
		    method: 'post',
		    params: query
		});
	},
	//订单图表
	getAgentOrderInfo(query){
		return http({
		    url: this.baseurl+'/dingdmain/selectAgentOrderInfo',
		    method: 'post',
		    params: query
		});
	},
    //预测完成度图表
	selectList(){
		return http({
			url: '/api/swyl/v1/demo/yuceFinishProportion/selectList',
			method: 'post'
		});
	},
}